import React from "react";

export const AfternoonIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M11.6167 1.93604V3.87206M11.6167 19.3603V21.2963M3.87255 11.6162H1.93652M6.11265 6.11216L4.74367 4.74318M17.1207 6.11216L18.4897 4.74318M6.11265 17.1242L4.74367 18.4931M17.1207 17.1242L18.4897 18.4931M21.2968 11.6162H19.3608M16.4567 11.6162C16.4567 14.2893 14.2898 16.4562 11.6167 16.4562C8.94356 16.4562 6.77659 14.2893 6.77659 11.6162C6.77659 8.94308 8.94356 6.7761 11.6167 6.7761C14.2898 6.7761 16.4567 8.94308 16.4567 11.6162Z"
      strokeWidth="1.93603"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
